// SPDX-License-Identifier: GPL-2.0-or-later
// Rede simulada para testes e para a opção de depuração do cliente: atraso fixo, jitter e perda
// como acontece num WebSocket (TCP): o pacote perdido é retransmitido um RTT depois e segura os
// que vêm atrás dele (entrega em ordem). Determinística com a semente.
/** Gerador congruencial simples (a rede simulada não faz parte da simulação do jogo). */
function lcg(seed) {
    let s = seed >>> 0 || 1;
    return () => {
        s = (Math.imul(s, 1664525) + 1013904223) >>> 0;
        return s / 0x100000000;
    };
}
/** Um sentido da conexão: entrega os pacotes em ordem, cada um no seu horário. */
export class SimulatedLink {
    conditions;
    queue = [];
    lastAt = 0;
    random;
    /** Pacotes perdidos e retransmitidos. */
    lost = 0;
    constructor(conditions, seed = 1) {
        this.conditions = conditions;
        this.random = lcg(seed);
    }
    send(data, now) {
        const c = this.conditions;
        let at = now + c.rttMs / 2 + this.random() * c.jitterMs;
        if (this.random() < c.loss) {
            this.lost++;
            at += Math.max(c.rttMs, 20) + 10; // retransmissão depois de um RTT
        }
        at = Math.max(at, this.lastAt); // TCP: ninguém passa à frente do retransmitido
        this.lastAt = at;
        this.queue.push({ at, data });
    }
    /** Pacotes que chegaram até `now`, em ordem. */
    receive(now) {
        let n = 0;
        while (n < this.queue.length && this.queue[n].at <= now)
            n++;
        return this.queue.splice(0, n).map((p) => p.data);
    }
    /** Quando chega o próximo pacote (ou Infinity). */
    nextArrival() {
        return this.queue[0]?.at ?? Infinity;
    }
}
//# sourceMappingURL=link.js.map